export enum previewTypes {
  FETCH_PREVIEW_REQUEST = "FETCH_PREVIEW_REQUEST",
  FETCH_PREVIEW_SUCCESS = "FETCH_PREVIEW_SUCCESS",
  FETCH_PREVIEW_FAILURE = "FETCH_PREVIEW_FAILURE",
}